const visualizationType = {
    SHADED_AREA: 'SHADED_AREA',
    BUBBLES: 'BUBBLES',
    DOT_DENSITY: 'DOT_DENSITY',
};

export default visualizationType;
